import { createAndCaptureError } from '@/wabunka-src/common/utils/sentry';

/**
 * タグ付きでエラーを作成 & sentryに送信する関数をまとめたコンポーザブル
 * エラーはNuxtのcreateErrorで作成されている
 * ref: https://nuxt.com/docs/api/utils/create-error
 * @returns
 */
export const useErrorCreator = () => {
  const createWabunkaError = (params: Parameters<typeof createAndCaptureError>[0]) => {
    return createAndCaptureError(params, 'wabunka');
  };

  return { createWabunkaError };
};
